/** @flow
 * CHECKOUT ERRORS
 * Component to display the current errors returned by the server during
 * the checkout process
 */
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
// Styles
import './CheckoutErrors.css';
// Logger
import { logException } from '../../logHelper';

type Props = {
  errors: string[],
  dismiss: () => void,
  showErrorFields: boolean,
};

const CheckoutErrors = ({ errors, dismiss, showErrorFields }: Props) => {
  const currentError = errors.length > 0 ? errors[errors.length - 1] : null;
  const parseError = (error: string) => {
    try {
      const parsedError = JSON.parse(error);
      let errorString = '';

      if (!showErrorFields && parsedError.error) {
        return parsedError.error;
      }

      if (parsedError.error) {
        errorString += parsedError.error;
      }

      if (parsedError.errors.base) {
        const values = _.values(parsedError.errors.base);
        for (let i = 0; i < values.length; i++) {
          errorString += ` ${values[i]}`;
        }
      }

      return errorString;
    } catch (err) {
      logException(err);
      return error;
    }
  };

  if (!currentError) {
    return null;
  }

  return (
    <div className="checkout-error-main">
      <div className="checkout-error alert alert-danger" role="alert">
        <div className="checkout-error-message">
          {parseError(currentError)}
        </div>
        <button
          type="button"
          className="checkout-error-close"
          aria-label="Close"
          onClick={dismiss}
        >
        <span aria-hidden="true" className="close-icon">X</span>
        </button>
      </div>
    </div>
  );
};

export default CheckoutErrors;
